import "../style/style-cv-1.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faUser } from "@fortawesome/free-solid-svg-icons";
import { ProgressBar } from "react-bootstrap";

import { Link } from "react-router-dom";

export default function CVTemplate1(propos) {
  return (
    <>
      <div className="row" style={{ padding: 10 }} id="pdf">
        {/*A propos de moi  */}
        <div className="col-sm-4" style={{ textAlign: "center" }}>
          {propos.cv.photo != null ? (
            <img
              className="img-fluid img"
              src={
                process.env.NODE_ENV === "production"
                  ? process.env.REACT_APP_API_BASE_URL_PROD +
                    `/storage/images/${propos.cv.photo}`
                  : process.env.REACT_APP_API_BASE_URL_LOCAL +
                    `storage/images/${propos.cv.photo}`
              }
              alt="image"
              style={{ fontSize: "100x", width: "auto", height: "150px" }}
            />
          ) : (
            <FontAwesomeIcon icon={faUser} size="6x" />
          )}

          <p className="icon" style={{ fontWeight: "bold" }}>
            #{propos.cv.id}
          </p>
        </div>

        <div className="col-sm-8">
          <br />
          <p style={{ fontSize: "25px" }}>
            {propos.cv.civilite} : {propos.cv.nom}
          </p>
          <p style={{ fontSize: "17px" }}> {propos.cv.domain_d_etude} </p>
          <p style={{ borderTop: "1px solid black" }}></p>
          <span style={{ fontWeight: "bold" }}>Tel : </span>{" "}
          <span>{propos.cv.telephone}</span> |
          <span style={{ fontWeight: "bold" }}> Email : </span>{" "}
          <span> {propos.cv.email}</span> |
          <span style={{ fontWeight: "bold" }}> Date de naissance :</span>{" "}
          <span>{propos.cv.date_naissance}</span>
          <br />
        </div>

        {propos.cv.description != "null" && propos.cv.description != null ? (
          <>
            <div
              className="col-sm-12"
              style={{ borderTop: "3px solid #eee", marginTop: "10px" }}
            >
              <br />
            </div>
            <div className="col-sm-3">
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderBottom: "2px solid black",
                  float: "inline-end",
                }}
              >
                À propos de moi
              </span>
            </div>
            <div className="col-sm-1"></div>
            <div className="col-sm-8">
              <p>{propos.cv.description}</p>
            </div>
          </>
        ) : null}

        <div className="col-sm-12" style={{ borderTop: "3px solid #eee" }}>
          <br />
        </div>

        {/* FORMATION */}
        <div className="col-sm-3">
          <span
            style={{
              fontWeight: "bold",
              fontSize: "20px",
              borderBottom: "2px solid black",
              float: "inline-end",
            }}
          >
            Formations
          </span>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-8">
          {propos.formations.map((formation, index) => (
            <div key={index}>
              <span style={{ fontWeight: "bold" }}>
                {formation.titre_formation}
              </span>
              {formation.date_fin == null && formation.encoure == 1 ? (
                <span style={{ float: "inline-end" }}>
                  {formation.date_debut} - Encoure
                </span>
              ) : (
                <span style={{ float: "inline-end" }}>
                  {formation.date_debut} - {formation.date_fin}
                </span>
              )}

              <p>{formation.specialite}</p>
              <p style={{ fontWeight: "bold" }}>
                {" "}
                Etablissement :{" "}
                <i>
                  {" "}
                  {formation.etablissement} - {formation.ville}
                </i>{" "}
              </p>

              <hr style={{ border: "none", borderTop: "3px dotted #eee" }} />
            </div>
          ))}
        </div>

        {/* Experience */}
        {propos.experiences.length === 0 ? null : (
          <>
            <div className="col-sm-12" style={{ borderTop: "3px solid #eee" }}>
              <br />
            </div>
            <div className="col-sm-3">
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderBottom: "2px solid black",
                  float: "inline-end",
                }}
              >
                Experiences
              </span>
            </div>

            <div className="col-sm-1"></div>

            <div className="col-sm-8">
              {propos.experiences.map((experience, index) => (
                <div key={index}>
                  <span style={{ fontWeight: "bold" }}>
                    {experience.titre_projet}{" "}
                  </span>
                  {experience.date_fin == null && experience.encour == 1 ? (
                    <span style={{ float: "inline-end" }}>
                      {experience.date_debut} - Encoure{" "}
                    </span>
                  ) : (
                    <span style={{ float: "inline-end" }}>
                      {experience.date_debut} - {experience.date_fin}{" "}
                    </span>
                  )}

                  <p style={{ fontWeight: "bold" }}>
                    Entreprise : <i>{experience.nom_entreprise} </i>{" "}
                  </p>

                  <p>{experience.description}</p>

                  <hr
                    style={{ border: "none", borderTop: "3px dotted #eee" }}
                  />
                </div>
              ))}
            </div>
          </>
        )}

        {/* Competences */}
        {propos.competences.length === 0 ? null : (
          <>
            <div className="col-sm-12" style={{ borderTop: "3px solid #eee" }}>
              <br />
            </div>
            <div className="col-sm-3">
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderBottom: "2px solid black",
                  float: "inline-end",
                }}
              >
                Compétences
              </span>
            </div>
            <div className="col-sm-1"></div>
            <div className="col-sm-8">
              {propos.competences.map((competence, index) => (
                <div className="row" key={index}>
                  <div className="col-sm-5">
                    <span>{competence.nom}</span>
                  </div>
                  <div className="col-sm-5">
                    <ProgressBar
                      now={competence.niveau}
                      label="pro"
                      visuallyHidden
                    />
                  </div>
                  <div
                    className="col-sm-2"
                    style={{ textAlign: "end", fontSize: "0.7rem" }}
                  >
                    <Link
                      to="#"
                      onClick={() => propos.suprimerCompetence(competence.id)}
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        className="fa-lg text-danger icon"
                      />
                    </Link>
                  </div>
                  <div className="col-sm-2">
                    <br />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="col-sm-12" style={{ borderTop: "3px solid #eee" }}>
          <br />
        </div>
        {/* Langues */}
        <div className="col-sm-3">
          <span
            style={{
              fontWeight: "bold",
              fontSize: "20px",
              borderBottom: "2px solid black",
              float: "inline-end",
            }}
          >
            Langues
          </span>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-8">
          {propos.langues.map((langue, index) => (
            <div className="row" key={index}>
              <div className="col-5">
                <span>{langue.nom}</span>{" "}
              </div>
              <div className="col-5">
                {" "}
                <span>{langue.niveau}</span>{" "}
              </div>
              <div className="col-12">
                <hr style={{ border: "none", borderTop: "3px dotted #eee" }} />
              </div>
            </div>
          ))}
        </div>

        <br />
      </div>
    </>
  );
}
